
import { Component, Mixins, Prop } from 'vue-property-decorator'

import CustomTagMixin from '@/@next/mixins/CustomTag'
import { CImage } from '@/@next/components/image'
import { CLoader } from '@/components/loader'
// import { CButton, CButtonLabel, CButtonIcon } from '@/components/form-controls/button'
import { messages } from '@/@next/i18n'

const config = {
  name: 'c-content-image-comparison-slider',
  i18n: { messages },
  components: {
    CImage,
    CLoader
  }
}

@Component(config)
export default class ImageComparisonSlider extends Mixins(CustomTagMixin) {
  @Prop({ type: Object, required: true }) content!: any
  @Prop({ type: String, required: false, default: '' }) contextId!: string

  get leftImage () {
    if (!this.content) return null
    return this.content.data.leftImage || null
  }

  get rightImage () {
    if (!this.content) return null
    return this.content.data.rightImage || null
  }

  get title () {
    if (!this.content) return null
    return this.content.data.i18n.title?.value || null
  }

  get text () {
    if (!this.content) return null
    return this.content.data.i18n.text?.value || null
  }

  get options () {
    if (!this.content) return {}
    return this.content.data.options
  }
}
